<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="app-confirm-mask"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
      @click.self="onBackdrop"
    >
      <div class="app-confirm-card" :class="{ 'is-alert-only': alertOnly }">
        <button type="button" class="app-confirm-x" aria-label="닫기" @click="onX">
          <AppIcon name="close" :size="16" />
        </button>
        <h2 :id="titleId" class="app-confirm-title">{{ title }}</h2>
        <p class="app-confirm-msg">{{ message }}</p>
        <div class="app-confirm-actions" :class="{ 'is-single': alertOnly }">
          <button
            v-if="!alertOnly"
            type="button"
            class="app-confirm-btn app-confirm-btn--cancel"
            @click="onCancel"
          >
            {{ cancelText }}
          </button>
          <button type="button" class="app-confirm-btn app-confirm-btn--ok" @click="onConfirm">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    title?: string
    message?: string
    confirmText?: string
    cancelText?: string
    alertOnly?: boolean
  }>(),
  {
    title: '확인',
    message: '',
    confirmText: '확인',
    cancelText: '취소',
    alertOnly: false,
  }
)

const emit = defineEmits<{
  'update:modelValue': [boolean]
  confirm: []
  cancel: []
}>()

const titleId = computed(() => 'app-confirm-title')

const onBackdrop = () => {
  if (props.alertOnly) {
    onConfirm()
    return
  }
  onCancel()
}

const onConfirm = () => {
  emit('update:modelValue', false)
  emit('confirm')
}

const onCancel = () => {
  emit('update:modelValue', false)
  emit('cancel')
}

/** 우측 상단 X — 배경 탭과 동일 (알림은 확인, 확인창은 취소) */
const onX = () => {
  if (props.alertOnly) {
    onConfirm()
    return
  }
  onCancel()
}
</script>
